import React from "react";
import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";

/**
 * ValueRow - one labelled row of a bordered value card (2026-08-15
 * design overhaul, operator-approved mockup) : muted label cell, mono
 * value cell, and an optional attached Copy control. The card idiom
 * exists because a transcribable value is the one thing the customer
 * must carry away exactly - it earns the strongest visual containment
 * on the page. Used by the Step 3 challenge data card.
 */
export function ValueRow({ label, value, copy }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-[130px_1fr_auto] items-stretch">
      <div className="flex items-center px-4 py-2 sm:py-3 bg-gray-50 dark:bg-gray-900/50 text-sm font-medium text-muted sm:border-r border-gray-200 dark:border-gray-700">
        {label}
      </div>
      <div className="flex items-center px-4 py-3 font-mono text-sm text-heading break-all">
        {value}
      </div>
      {copy ? (
        <div className="flex items-center justify-end px-2 sm:border-l border-gray-200 dark:border-gray-700">
          {copy}
        </div>
      ) : (
        <div />
      )}
    </div>
  );
}

/**
 * ValueRowCopyButton - the row-attached tri-state copy control.
 * Visible text is the short form the row design uses ; the aria-label
 * carries the FULL artifact-named tri-state strings - four
 * visually-identical Copy controls can share one screen, and the
 * artifact-named accessible labels are the standing a11y contract the
 * suite pins.
 */
export function ValueRowCopyButton({
  label,
  failedLabel,
  value,
  fieldKey,
  copyStatus,
  onCopy,
  disabled,
}) {
  const state = copyStatus[fieldKey];
  return (
    <button
      type="button"
      onClick={() => onCopy(value, fieldKey)}
      disabled={disabled}
      aria-label={
        state === false ? failedLabel : state ? label + " Copied" : label
      }
      className="inline-flex items-center text-sm font-semibold text-link px-3 py-2 rounded-md hover:bg-blue-50 dark:hover:bg-blue-900/30 disabled:text-muted disabled:cursor-not-allowed whitespace-nowrap focus:outline-hidden focus-visible:ring-2 focus-visible:ring-blue-500"
    >
      <ClipboardDocumentIcon className="w-4 h-4 mr-1" aria-hidden="true" />
      {state === false ? "Copy Failed" : state ? "Copied!" : "Copy"}
    </button>
  );
}
